// TODO: use all messages from @ezugi/constants
export const GAME_RESULT = 'GameResults';
export const WON_SIDE_BETS = 'WonSideBets';
